/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Participation_Agreement_CurrentInputs */

const en_admin_participation_agreement_current = /** @type {(inputs: Admin_Participation_Agreement_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View current PDF`)
};

const de_admin_participation_agreement_current = /** @type {(inputs: Admin_Participation_Agreement_CurrentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktuelles PDF ansehen`)
};

/**
* | output |
* | --- |
* | "View current PDF" |
*
* @param {Admin_Participation_Agreement_CurrentInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_participation_agreement_current = /** @type {((inputs?: Admin_Participation_Agreement_CurrentInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Participation_Agreement_CurrentInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_participation_agreement_current(inputs)
	return en_admin_participation_agreement_current(inputs)
});